import { browserHistory } from 'common/utils/browserHistory';
import caseRoute from './caseRoute';

function goToCase(serviceCase, query = {}, groupId = '', navigationState = {}) {
  const pathname = caseRoute(serviceCase, groupId);

  browserHistory.push({
    pathname,
    query,
    state: navigationState,
  });
}

export default goToCase;
